import React from 'react'
import { connect } from 'react-redux'
import { Field, getFormValues } from 'redux-form'
import { Button } from 'semantic-ui-react'

import FieldInput, { InputType as type } from 'components/SemanticForm'
import { StdCard, RowFields } from 'components'
import { Cont, BottomActionsContainer } from './styled'

const ReceiveInformationComponent = (props) => {

  const { 
    // props
    onCancelClick=null
  } = props

  return (
    <StdCard title={<span className='stepTitle'>Return Bank Guarantee</span>}>
      <Cont>
        <RowFields>
          <Field 
            name="returnDate"
            label="Return Date"
            component={FieldInput}
            type={type.date}
            className='halfRow'
            require
          />
        </RowFields>
        <BottomActionsContainer>
          <Button
            type='button'
            content='Cancel'
            color='red'
            onClick={onCancelClick}
          />
          <Button
            content='Update'
            color='green'
          />
        </BottomActionsContainer>
      </Cont>
    </StdCard>
  )
}

const mapStateToProps = (state, props) => {
  return {
  }
}

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(ReceiveInformationComponent)
